import {Check} from "@sparkware/app-utils";

export function formatErrorForLogging(err?: any): string {
    if(Check.isObject(err) || Check.isArray(err)) {
        return JSON.stringify(err);
    }

    return err?.toString() ?? "";
}